import React from "react";

import { DataProviderContext } from "app/main/DataProvider";
import { BreadcrumbItem } from "app/breadcrumbs/Breadcrumbs/interfaces";
import { clientConfig } from "app/config";

const labelMap: { [key: string]: string } = {
    aktien: "Aktien",
    indizes: "Indizes",
    fonds: "Fonds",
    rohstoffe: "Rohstoffe",
    etf: "ETF",
    news: "News",
    analysen: "Analysen"
};

const urlMap: { [key: string]: string } = {
    aktien: clientConfig.sharesLandingUrl,
    indizes: clientConfig.indizesLandingUrl,
    fonds: clientConfig.fondsLandingUrl,
    rohstoffe: clientConfig.commoditiesLandingUrl,
    etf: clientConfig.etfsLandingUrl,
    news: "",
    analysen: ""
};

const staticBreadcrumbs: BreadcrumbItem[] = [
    {
        url: "https://www.t-online.de",
        label: "Home"
    },
    {
        url: "https://www.t-online.de/finanzen/",
        label: "Finanzen"
    },
    {
        url: "https://www.t-online.de/finanzen/boerse/",
        label: "Börse"
    }
];

export const useBreadcrumbs = (finalLabel?: string): BreadcrumbItem[] => {
    const { url } = React.useContext(DataProviderContext);

    const parts: string[] = url.split("/");
    const ignoredPaths = ["finanzen", "boerse", ""];

    const pathMembers = parts
        .filter(part => {
            return ignoredPaths.indexOf(part) < 0 && labelMap.hasOwnProperty(part);
        })
        .map((part: string) => {
            return {
                url: urlMap[part],
                label: labelMap[part]
            };
        });

    const breadcrumbs = staticBreadcrumbs.concat(pathMembers);

    if (finalLabel) {
        breadcrumbs.push({
            url: null,
            label: finalLabel
        });
    } else {
        breadcrumbs[breadcrumbs.length - 1].url = null;
    }

    return breadcrumbs;
};
